import { Injectable } from '@angular/core';
import { AbstractControl, Validators, UntypedFormGroup, UntypedFormArray, ValidatorFn } from '@angular/forms';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class ValidationService {

  public static dateRangeValidator(fromControl: AbstractControl, toControl: AbstractControl): () => {} {
    return () => {
      if (!fromControl.value || !toControl.value) { return; }
      const from: Date = fromControl.value;
      const to: Date = toControl.value;
      return moment(from).isSame(moment(to), 'minute') || moment(from).isAfter(moment(to)) ? { dateRangeError: true } : '';
    };
  }

  public static dateRequiredValidator(fromControl: AbstractControl, toControl: AbstractControl): () => {} {
    return () => !fromControl.value && !toControl.value ? { required: true } : null;
  }

  public static ratioRangeValidator(upperLimitRatio: AbstractControl, lowerLimitRatio: AbstractControl): () => {} {
    return () => {
      if (upperLimitRatio.value === null || lowerLimitRatio.value === null) { return; }
      return upperLimitRatio.value < lowerLimitRatio.value ? { ratioRangeError: true } : '';
    };
  }

  public static exceedUpperLimitRatioValidator(ratio: AbstractControl, upperLimitRatio: AbstractControl): () => {} {
    return () => {
      if (ratio.value === null || upperLimitRatio.value === null) { return; }
      return ratio.value > upperLimitRatio.value ? { upperLimitRatioError: true } : '';
    };
  }

  public static belowLowerLimitRatioValidator(ratio: AbstractControl, lowerLimitRatio: AbstractControl): () => {} {
    return () => {
      if (ratio.value === null || lowerLimitRatio.value === null) { return; }
      return ratio.value < lowerLimitRatio.value ? { lowerLimitRatioError: true } : '';
    };
  }

  public static duplicateOuterDealIdValidator(form: AbstractControl, formGroup: UntypedFormGroup): () => {} {
    return () => {
      const id = form.value;
      let cnt = 0;

      (formGroup.controls.dealDetails as UntypedFormArray).controls.forEach((v) => {
        if (v.get('outerDealId').value === id) {
          cnt++;
        }
      });

      // 重複が発生した場合エラーとする
      return cnt > 1 ? { duplicateOuterDealIdError: true } : '';
    };
  }

  /**
   * メールドメインValidator
   * @remarks
   * 有効なメールドメインか検証を行う。
   * @param domains 有効なメールドメインのリスト
   * @returns Validator関数({@link ValidatorFn})
   */
  public static emailDomainValidator(domains: string[]): ValidatorFn {
    const pattern = domains.join('|').replace('.', '\\.');
    return Validators.pattern('^.*(' + pattern + ')$');
  };
}
